import { useEffect } from "react";
import { makeStyles, Typography, Grid } from "@material-ui/core";

import { header, timeOption, options } from "../../sample";
import { ShaDowBox } from "../../../../../components/boxes";
import SettingHeader from "../../../../../components/SettingHeader";
import { SwitchButton } from "../../../../../components/SwitchButton";
import AlertBoxHeader from "./AlertBoxHeader";
import { alerts, notifications } from "../../sample";
import { COLORS } from "../../../../../theme/colors";
import { SettingActions } from "../../../../../components/SettingHeader/settingActions";

export const useStyles = makeStyles(() => ({
  switchLabel: {
    fontWeight: 400,
    letterSpacing: 0.2
  },
  box1: {
    marginTop: 40,
    marginBottom: 10
  },
  box2: {
    marginTop: 60,
    marginBottom: 10
  },
  headerContent: {
    marginLeft: 50,
    paddingTop: 40,
    paddingBottom: 23
  }
}));

export const AlertNotifications = () => {
  const classes = useStyles();

  const fetchNotificationAlerts = async () => {};

  useEffect(() => {
    fetchNotificationAlerts();
  }, []);

  const handleChangeAlert = async () => {};

  return (
    <>
      <SettingActions />
      <ShaDowBox>
        <div className={classes.headerContent}>
          <SettingHeader
            title={header.alertsnotifications.title}
            subtitle={header.alertsnotifications.subtitle}
            img={header.alertsnotifications.img}
          />
          <Grid xs={6} className={classes.box1}>
            <AlertBoxHeader
              title="INSIGHTS ALERTS"
              type="insight"
              options1={timeOption}
              options2={options}
              label1="Send:"
              send="Weekly"
              to="Operator"
              intervalValue={alert["insight_interval"]?.toLowerCase()}
              roleValue={alert["insight_role"]?.toLowerCase()}
              label2="To:"
              changeInsights={handleChangeAlert}
            />
          </Grid>
          <Grid xs={6}>
            <ShaDowBox style={{ border: `1px solid ${COLORS.darks[0][10]}` }}>
              <div style={{ padding: "20px" }}>
                {alerts?.map((item) => {
                  return (
                    <Grid
                      key={`${item.value}${alert[item.value]}`}
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Typography>{item.label}</Typography>
                      <SwitchButton
                        checked={!!alert[item.value]}
                        handleChangeAlert={() =>
                          handleChangeAlert({
                            [item.value]: !alert[item.value]
                          })
                        }
                      />
                    </Grid>
                  );
                })}
              </div>
            </ShaDowBox>
          </Grid>
          <Grid xs={6} className={classes.box2}>
            <AlertBoxHeader
              title="ONGOING PORTFOLIO CHANGES"
              type="portfolio"
              options1={timeOption}
              options2={options}
              label1="Send:"
              label2="To:"
              send={"Operator"}
              to="Daily"
              intervalValue={alert["portfolio_interval"]?.toLowerCase()}
              roleValue={alert["portfolio_role"]?.toLowerCase()}
              changeInsights={handleChangeAlert}
            />
          </Grid>
          <Grid xs={6}>
            <ShaDowBox style={{ border: `1px solid ${COLORS.darks[0][10]}` }}>
              <div style={{ padding: "20px" }}>
                {notifications?.map((item) => {
                  return (
                    <Grid
                      key={`${item.value}${alert[item.value]}`}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      container
                    >
                      <Typography className={classes.switchLabel}>
                        {item.label}
                      </Typography>
                      <SwitchButton
                        checked={alert[item.value] === true ? true : false}
                        handleChangeAlert={() =>
                          handleChangeAlert({
                            [item.value]: !alert[item.value]
                          })
                        }
                      />
                    </Grid>
                  );
                })}
              </div>
            </ShaDowBox>
          </Grid>
        </div>
      </ShaDowBox>
    </>
  );
};
